import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from 'admin/common/icons/CloseIcon';
import aibirdeyeIcon from '../../assets/images/aibirdeye.svg';
import { buildIssueShortageAlertLines } from './zoneIssueShortageUtils';
import './ZoneInventoryAlertToast.scss';

export default function ZoneInventoryAlertToast({
  alertData,
  onClose,
  disabled = false,
  stackAbove = false,
  stackIndex = 0,
}) {
  const { t } = useTranslation();
  const [mounted, setMounted] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!alertData) {
      setVisible(false);
      setMounted(false);
      return undefined;
    }

    setMounted(true);
    const frameId = requestAnimationFrame(() => {
      requestAnimationFrame(() => setVisible(true));
    });

    return () => cancelAnimationFrame(frameId);
  }, [alertData]);

  const handleTransitionEnd = (event) => {
    if (event.propertyName !== 'transform') return;
    if (!visible) {
      setMounted(false);
    }
  };

  const handleClose = () => {
    if (disabled) return;
    setVisible(false);
    onClose?.();
  };

  if (!mounted || !alertData) {
    return null;
  }

  const lines = buildIssueShortageAlertLines(alertData, t);

  return (
    <div
      className={`zone-inventory-alert-toast${
        visible ? ' zone-inventory-alert-toast--visible' : ''
      }${disabled ? ' zone-inventory-alert-toast--disabled' : ''}${
        stackAbove || stackIndex > 0 ? ' zone-inventory-alert-toast--stacked' : ''
      }`}
      style={{ '--toast-stack-index': stackIndex }}
      role="status"
      aria-live="polite"
      onTransitionEnd={handleTransitionEnd}
    >
      <header className="zone-inventory-alert-toast__header">
        <div className="zone-inventory-alert-toast__title">
          <img
            src={aibirdeyeIcon}
            alt=""
            className="zone-inventory-alert-toast__icon"
          />
          <span>{t('Inventory Alert', { defaultValue: 'Inventory Alert' })}</span>
        </div>
        <button
          type="button"
          className="zone-inventory-alert-toast__close"
          onClick={handleClose}
          disabled={disabled}
          aria-label={t('Close')}
        >
          <CloseIcon color="#D9D9D9" width="14" height="14" />
        </button>
      </header>
      <div className="zone-inventory-alert-toast__message">
        <p>{lines.previousLine}</p>
        <p>{lines.currentLine}</p>
        <p>{lines.questionLine}</p>
      </div>
    </div>
  );
}
